import React from 'react';

// Particles
import Particles from 'react-particles-js';

// Local Imports
import CtaContact from './CtaContact';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const CtaContainer = () => {
	// Component Hooks
	const { width } = useWindowDimensions();

	return (
		<div className='cta-particles-background'>
			<Particles
				height={width > 768 ? 300 : 450}
				params={{
					particles: {
						color: {
							value: 'rgba(255, 255, 255, 0.4)',
						},
						line_linked: {
							color: {
								value: 'rgba(255, 255, 255, 0.2)',
							},
						},
						number: {
							value: width > 768 ? 80 : 30,
						},
						size: {
							value: 1,
						},
					},
					interactivity: {
						events: {
							onhover: {
								enable: true,
								mode: 'repulse',
							},
						},
					},
					retina_detect: true,
				}}
			/>
			<div className='cta-container'>
				<CtaContact />
			</div>
		</div>
	);
};

export default CtaContainer;
